import React from 'react';
import Icon from '../Icon'

export default function PairIcon({ title, fontSize }) {
    return (<Icon icon="users-alt-4" title={title} style={{ color: "cadetblue", fontSize: (fontSize)?fontSize:"16px", paddingRight: (title!== undefined)?"4px":"0px" }} className="proam-icon"/>);
};